module.exports = __webpack_public_path__ + "./img/Spinner.png?f40c7df7606ccee793cb1bc1e4db7546";